import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default Multiselect



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js